<template>
  <PageWrapper :isLoading="isLoading" isChildWrapper>
    <template #title> تنظیمات استاد محبوب </template>
    <BRow>
      <BCol cols="6">
        <CustomAppendText
          :isText="true"
          customRules="required|min:1"
          inputId="masterPopularPercent"
          inputLabel="درصد مورد نظر برای محبوب شدن"
          inputPlaceholder="80"
          v-model="popularMasterPayload.masterPopularPercent"
        >
          <template #append> % </template>
        </CustomAppendText>
      </BCol>
      <BCol cols="6">
        <CustomAppendText
          :isText="true"
          customRules="required|min:1"
          inputId="masterPopularCount"
          inputLabel="حداقل تعداد شرکت کنندگان"
          inputPlaceholder="20"
          v-model="popularMasterPayload.masterPopularCount"
        >
          <template #append> نفر </template>
        </CustomAppendText>
      </BCol>
      <BCol cols="6">
        <CustomAppendText
          :isText="true"
          customRules="required|min:1"
          inputId="masterBasePricePercent"
          inputLabel="درصد افزایش حقوق استاد"
          inputPlaceholder="20"
          v-model="popularMasterPayload.masterBasePricePercent"
        >
          <template #append> % </template>
        </CustomAppendText>
      </BCol>
      <BCol cols="6">
        <CustomAppendText
          :isText="true"
          customRules="required|min:1"
          inputId="userBasePricePercent"
          inputLabel="درصد افزایش پرداخت زبان آموز"
          inputPlaceholder="20"
          v-model="popularMasterPayload.userBasePricePercent"
        >
          <template #append> % </template>
        </CustomAppendText>
      </BCol>
      <BCol cols="12">
        <BFormGroup label="تصویر نمایشی استاد محبوب" label-for="imageFile">
          <BFormFile
            @input="handleImageFile"
            v-model="uploadImagePayload.imageFile"
            ref="imageFile"
            id="imageFile"
            accept=".jpg,.jpeg,.png"
          ></BFormFile>
        </BFormGroup>
      </BCol>
      <BCol cols="12" class="position-relative" v-if="imagePreview">
        <BImg
          v-if="imagePreview"
          rounded
          class="custom-image"
          center
          fluid
          :src="imagePreview"
        ></BImg>
        <BButton
          size="sm"
          variant="transparent"
          class="custom-delete-btn"
          @click="deletePreviewImage"
        >
          <FeatherIcon size="40" class="text-danger" icon="Trash2Icon" />
        </BButton>
      </BCol>
      <BCol cols="12" class="d-flex align-items-center justify-content-end">
        <BButton variant="success" @click="setNewPopularConfig">
          ویرایش تنظیمات استاد محبوب
        </BButton>
      </BCol>
    </BRow>
  </PageWrapper>
</template>

<script>
export default {
  mounted() {
    this.getPopularMasterDetails();
  },
  data() {
    return {
      isLoading: false,
      imagePreview: null,
      uploadImagePayload: {
        imageFile: null,
        fileType: 0,
        title: null,
        alt: null,
        description: null,
      },
      popularMasterPayload: {
        masterPopularPercent: null,
        masterPopularCount: null,
        masterBasePricePercent: null,
        userBasePricePercent: null,
        imageLink: "",
      },
    };
  },
  methods: {
    deletePreviewImage() {
      if (this.uploadImagePayload && this.uploadImagePayload.imageFile) {
        URL.revokeObjectURL(this.imagePreview);
        this.imagePreview = null;
        this.uploadImagePayload.imageFile = null;
        if (this.$refs.imageFile) {
          this.$refs.imageFile.reset();
        }
      }
    },
    handleImageFile() {
      if (this.uploadImagePayload.imageFile) {
        this.imagePreview = URL.createObjectURL(
          this.uploadImagePayload.imageFile
        );
      }
    },
    async getPopularMasterDetails() {
      try {
        this.isLoading = true;
        const _this = this;
        const getPopularMasterDetails = new GetPopularMasterDetails(_this);
        await getPopularMasterDetails.fetch((res) => {
          if (res.isSuccess) {
            this.popularMasterPayload = res.data;
            if (this.popularMasterPayload.imageLink) {
              this.imagePreview = this.popularMasterPayload.imageLink;
            }
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async setNewPopularConfig() {
      try {
        this.isLoading = true;
        if (this.uploadImagePayload.imageFile) {
          await this.uploadPopularMasterPic();
        }
        const _this = this;
        const setPopularMasterDetails = new SetPopularMasterDetails(_this);
        setPopularMasterDetails.setRequestParam(_this.popularMasterPayload);
        await setPopularMasterDetails.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              position: "bottom-center",
              props: {
                title: "ویرایش شد",
                icon: "MessageIcon",
                variant: "success",
                text: "تنظیمات استاد محبوب ویرایش شد.",
              },
            });
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.message || "مشکلی پیش آمد، لطفا دوباره امتحان کنید.",
              },
            });
          }
        });
      } catch (error) {
      } finally {
        this.isLoading = false;
      }
    },
    async generateImageFormData() {
      return new Promise((resolve, reject) => {
        const myFormData = new FormData();
        Object.keys(this.uploadImagePayload).forEach((key) => {
          myFormData.append(key, this.uploadImagePayload[key]);
        });
        resolve(myFormData);
      });
    },
    async uploadPopularMasterPic() {
      try {
        this.isLoading = true;
        const _this = this;
        const uploadImage = new UploadImage(_this);
        uploadImage.setFormData(await _this.generateImageFormData());
        await uploadImage.sendFormData((res) => {
          if (res.data.url) {
            _this.popularMasterPayload.imageLink = res.data.url;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    PageWrapper,
    CustomAppendText,
    BRow,
    BCol,
    BButton,
    BFormFile,
    BFormGroup,
    BImg,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomAppendText from "@/views/components/Utils/CustomAppendText.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {
  BRow,
  BCol,
  BButton,
  BFormFile,
  BFormGroup,
  BImg,
} from "bootstrap-vue";
import {
  GetPopularMasterDetails,
  SetPopularMasterDetails,
} from "@/libs/Api/SiteSetting";
import { UploadImage } from "@/libs/Api/Uploader";
</script>
<style>
.custom-image {
  max-height: 200px;
}
</style>
